/**
 * @license Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

// The editor creator to use.
import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import CKBox from '@ckeditor/ckeditor5-ckbox/src/ckbox';
import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';
import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize';
import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';

import ImageResizeEditing from '@ckeditor/ckeditor5-image/src/imageresize/imageresizeediting';
import ImageResizeHandles from '@ckeditor/ckeditor5-image/src/imageresize/imageresizehandles';

import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock';
import Link from '@ckeditor/ckeditor5-link/src/link';
import List from '@ckeditor/ckeditor5-list/src/list';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import PictureEditing from '@ckeditor/ckeditor5-image/src/pictureediting';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableColumnResize from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';

import TableProperties from '@ckeditor/ckeditor5-table/src/tableproperties';
import TableCellProperties from '@ckeditor/ckeditor5-table/src/tablecellproperties';
import TableCaption from '@ckeditor/ckeditor5-table/src/tablecaption';

import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation';
import CloudServices from '@ckeditor/ckeditor5-cloud-services/src/cloudservices';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import ImageBank from './plugins/ckeditor5-uploadImg/src';
import GeneralHtmlSupport from '@ckeditor/ckeditor5-html-support/src/generalhtmlsupport';
import FindAndReplace from '@ckeditor/ckeditor5-find-and-replace/src/findandreplace';
import Font from '@ckeditor/ckeditor5-font/src/font';
import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight';
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline';
import SelectAll from '@ckeditor/ckeditor5-select-all/src/selectall';

import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
import Code from '@ckeditor/ckeditor5-basic-styles/src/code';
import Subscript from '@ckeditor/ckeditor5-basic-styles/src/subscript';
import Superscript from '@ckeditor/ckeditor5-basic-styles/src/superscript';
import RemoveFormat from '@ckeditor/ckeditor5-remove-format/src/removeformat';
import SpecialCharacters from '@ckeditor/ckeditor5-special-characters/src/specialcharacters';
// A plugin that combines a basic set of special characters.
import SpecialCharactersEssentials from '@ckeditor/ckeditor5-special-characters/src/specialcharactersessentials';
import PageBreak from '@ckeditor/ckeditor5-page-break/src/pagebreak';
import AutoLink from '@ckeditor/ckeditor5-link/src/autolink';
import CodeBlock from '@ckeditor/ckeditor5-code-block/src/codeblock';
import SourceEditing from '@ckeditor/ckeditor5-source-editing/src/sourceediting';
import HtmlEmbed from '@ckeditor/ckeditor5-html-embed/src/htmlembed';
import WordCount from '@ckeditor/ckeditor5-word-count/src/wordcount';
import LinkImage from '@ckeditor/ckeditor5-link/src/linkimage';
import AI from "./plugins/ckeditor5-AI/src";
import FullScreen from "./plugins/ckeditor5-fullScreen/src";
// import TableModificationPlugin from "./plugins/ckeditor5-table/src";

export default class ClassicEditor extends ClassicEditorBase {
}
// Plugins to include in the build.
ClassicEditor.builtinPlugins = [SimpleUploadAdapter,
	FindAndReplace,
	GeneralHtmlSupport,
	ImageBank,
	Essentials,
	UploadAdapter,
	Autoformat,
	Bold,
	Italic,
	BlockQuote,
	CKBox,
	CKFinder,
	CloudServices,
	EasyImage,
	Heading,
	Image,
	ImageCaption,
	ImageStyle,
	ImageToolbar,
	ImageUpload,
	ImageResize,
	ImageResizeEditing,
	ImageResizeHandles,
	Indent,
	IndentBlock,
	Link,
	List,
	MediaEmbed,
	Paragraph,
	PasteFromOffice,
	PictureEditing,
	Table,
	TableToolbar,
	TableColumnResize,
	TableProperties,
	TableCellProperties,
	TableCaption,
	TextTransformation,
	Alignment,
	Font,
	Highlight,
	HorizontalLine,
	SelectAll,
	Underline,
	Strikethrough,
	Code,
	Subscript,
	Superscript,
	RemoveFormat,
	SpecialCharacters,
	SpecialCharactersEssentials,
	PageBreak,
	AutoLink,
	CodeBlock,
	SourceEditing,
	HtmlEmbed,
	WordCount,AI,LinkImage,FullScreen
];

// Editor configuration.
ClassicEditor.defaultConfig = {
	toolbar: {
		items: [
			'undo',
			'redo','|',
			'sourceEditing',
			'|',
			'findAndReplace',
			'|',
			'selectAll',
			'|',
			'heading',
			'|',
			'fontSize',
			'fontFamily',
			'fontColor',
			'fontBackgroundColor',
			'bold',
			'italic',
			'underline',
			'strikethrough',
			{
				label: 'Formatting',
				icon: 'text',
				items: ['superscript', 'subscript', 'code', 'removeFormat']
			},'|',
			'specialCharacters',
			'horizontalLine',
			'pageBreak',
			'|',
			'link',
			'imagebank',
			'insertTable',
			// 'highlight',
			{
				label: 'Insert',
				icon: 'plus',
				items: ['blockQuote', 'mediaEmbed', 'codeBlock', 'htmlEmbed']
			},
			'|',
			'Alignment',
			'|',
			'bulletedList',
			'numberedList',
			'outdent',
			'indent','AI','FullScreen'
		],
		shouldNotGroupWhenFull: true
	},
	// @ts-ignore
	mediaEmbed: {
		previewsInData: true
	},
	// @ts-ignore
	wordCount: {
		// @ts-ignore
		onUpdate: stats => {
			// Prints the current content statistics.
			// console.log(`Characters: ${stats.characters}\nWords: ${stats.words}`);
		}
	},

	image: {
		toolbar: [
			'imageTextAlternative', 'toggleImageCaption', '|', 'imageStyle:inline',
			{
				name: 'imageStyle:align',
				title: 'Wrap text:',
				items: ['imageStyle:alignLeft', 'imageStyle:alignRight',],
				defaultItem: 'imageStyle:alignLeft'
			},
			{
				name: 'imageStyle:pictures',
				title: 'Break text:',
				items: ['imageStyle:alignBlockLeft','imageStyle:alignCenter','imageStyle:alignBlockRight',],
				defaultItem: 'imageStyle:alignCenter'
			},
			'imageStyle:side', '|',
			'imageStyle:block',
			'|',
			'linkImage',
			'|',
			'resizeImage'
		]
	},

	resizeOptions: [
		{
			name: 'resizeImage:original',
			value: null,
			label: 'Original'
		},
		{
			name: 'resizeImage:40',
			value: '40',
			label: '40%'
		},
		{
			name: 'resizeImage:60',
			value: '60',
			label: '60%'
		}
	],
	heading: {
		options: [
			{ model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
			{ model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
			{ model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
			{ model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
			{ model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
			{ model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
			{ model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' },
		]
	},
	fontColor: {
		// colors: [
		// 	{
		// 		color: 'hsl(0, 0%, 0%)',
		// 		label: 'Black'
		// 	},
		// 	{
		// 		color: 'hsl(0, 0%, 30%)',
		// 		label: 'Dim grey'
		// 	},
		// 	{
		// 		color: 'hsl(0, 0%, 60%)',
		// 		label: 'Grey'
		// 	},
		// 	{
		// 		color: 'hsl(0, 0%, 90%)',
		// 		label: 'Light grey'
		// 	},
		// 	{
		// 		color: 'hsl(0, 0%, 100%)',
		// 		label: 'White',
		// 		hasBorder: true
		// 	},
		// ]
		colorPicker:true,
	},

	fontBackgroundColor: {

		// colors: [
		// 	{
		// 		color: 'hsl(0, 75%, 60%)',
		// 		label: 'Red'
		// 	},
		// 	{
		// 		color: 'hsl(30, 75%, 60%)',
		// 		label: 'Orange'
		// 	},
		// 	{
		// 		color: 'hsl(60, 75%, 60%)',
		// 		label: 'Yellow'
		// 	},
		// 	{
		// 		color: 'hsl(90, 75%, 60%)',
		// 		label: 'Light green'
		// 	},
		// 	{
		// 		color: 'hsl(120, 75%, 60%)',
		// 		label: 'Green'
		// 	}
		// ]
		colorPicker:true,
	},
	fontSize: {
		options: [12,14,16,18,20,22,24,28,36,48,60,72,
			'tiny',
			'default',
			'big'
		]
	},
	fontFamily: {
		options: [
			'default',
			'Ubuntu, Arial, sans-serif',
			'Ubuntu Mono, Courier New, Courier, monospace',
			'ABeeZee',
			'Abel',
			'Abril_Fatface','Acme','Actor','Adamina','Alegreya','Alice','Anton','Arimo','Arsenal','Arvo',
			'Average_Sans','Basic','Bitter','Cabin','Chivo','Cinzel','Comfortaa','Cormorant_Garamond','Didact_Gothic','DM_Mono','DM_Sans','DM_Serif_Text',
			'Exo_2','Fira_Sans','Fira_Sans_Extra_Condensed','Golos_Text','Grandstander','IBM_Plex_Sans','IBM_Plex_Serif','Inknut_Antiqua','Inter','Josefin_Sans',
			'Krona_One','Lato','Lora','Luckiest_Guy','Manrope','Merriweather','Merriweather_Sans','Montserrat','Mulish','Noto_Sans','Noto_Serif','Nunito','Old_Standard_TT',
			'Open_Sans','Orienta','Oswald','Oxygen','Piazzolla','Playfair_Display','Poppins','Prata','PT_Mono','PT_Sans','PT_Serif','PT_Serif_Caption','Quattrocento','Questrial',
			'Quicksand','Raleway','Roboto','Roboto_Condensed','Roboto_Mono','Roboto_Slab','Rubik','Smooch','Sora','Spectral','Syne','Tenor_Sans','Ubuntu','Work_Sans','Yanone_Kaffeesatz',
			'Yeseva_One'
		],
		supportAllValues: true
	},

	highlight: {
		options: [
			{
				model: 'greenMarker',
				class: 'marker-green',
				title: 'Green marker',
				color: 'rgb(25, 156, 25)',
				type: 'marker'
			},
			{
				model: 'yellowMarker',
				class: 'marker-yellow',
				title: 'Yellow marker',
				color: '#cac407',
				type: 'marker'
			},
			{
				model: 'redPen',
				class: 'pen-red',
				title: 'Red pen',
				color: 'hsl(343, 82%, 58%)',
				type: 'pen'
			}
		]
	},

	table: {
		contentToolbar: [
			'tableColumn', 'tableRow', 'mergeTableCells',
			'tableProperties', 'tableCellProperties', 'toggleTableCaption'
		],

		tableProperties: {
			// Configuration of the TableProperties plugin.
			// ...
		},

		tableCellProperties: {
			// Configuration of the TableCellProperties plugin.
			// ...
		}
	},
	// @ts-ignore
	htmlSupport: {
		allow: [
			{
				name: /.*/,
				attributes: true,
				classes: true,
				styles: true
			}
		]
	},
	// This value must be kept in sync with the language defined in webpack.config.js.
	language: 'zh-cn'
};

